import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./bannerV2.html";
/**
 * Full-bleed gradient notification banner for the modernized listing detail
 * page (`pages/listingDetailV2`, Figma 9639-130921), styled after the
 * home-page CMS promotion banner. Renders a centered message and breaks out to
 * the viewport edge, so the host must flow at page width.
 *
 * Shared by both v2 banner cases — offer-request success and private
 * listing — which differ in their message and (optionally) ARIA role.
 * It replaces v1's two separate components (`listing-privacy-banner` and the
 * design-system `ax-scoped-notification`) for the v2 layout.
 */
class BannerV2 extends LightningElement {
  constructor(...args) {
    super(...args);
    /** Message text shown in the banner. */
    this.message = '';
    /**
     * ARIA role for the message element. Pass `'status'` for the offer-request
     * success confirmation so assistive tech announces it as a polite live
     * region; leave unset for the static private-listing banner.
     */
    this.bannerRole = void 0;
    /**
     * Visual colorway. Pass `'offer'` for the offer-request success banner to
     * swap the default blue→blush gradient for the blue→mint offer gradient
     * (Figma 10339:13565); leave unset for the default private-listing banner.
     */
    this.variant = void 0;
  }
  /** Adds the `banner--offer` modifier when the offer colorway is requested. */
  get bannerClassName() {
    return this.variant === 'offer' ? 'banner banner--offer' : 'banner';
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(BannerV2, {
  publicProps: {
    message: {
      config: 0
    },
    bannerRole: {
      config: 0
    },
    variant: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(BannerV2, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;